import React,{useState,useEffect} from 'react';
import { Navbar } from "./components";
import { Header, About, Features, Statistics, Contactus, Footer, OurPeople} from "./containers";

const App = ({ data }) => {
    const [lastOffset, setLastOffset] = useState(window.pageYOffset);
    const [showBar, setShowBar] = useState(true);
    const [colorBar, setColorBar] = useState(false);
    useEffect(() => {
        document.title = data.Brand.name;
    }, [])
    let mql = window.matchMedia("(max-width: 767px)");
    const [smallScreen, setsmallScreen] = useState(mql.matches);
    mql.onchange = (e) => {setsmallScreen(e.matches);}
    document.addEventListener(
        'scroll',
        (event) => {
            setColorBar(window.pageYOffset > 100);
            if (window.pageYOffset > 150)
            {
                setShowBar(lastOffset > window.pageYOffset);
                setLastOffset(window.pageYOffset);
            }
        }, 
        { passive: true }
    );
    return (
        <div id="body">
            {showBar && <Navbar data={data} smScreen={smallScreen} bgColor={colorBar}/>}
            <Header data={data.Header}  smScreen={smallScreen}/>
            <main >
                {!data.About.hide && <About  data={data.About}  smScreen={smallScreen}/>}
                {!data.Features.hide && <Features  data={data.Features}  smScreen={smallScreen}/>}
                {!data.Statistics.hide && <Statistics  data={data.Statistics}  smScreen={smallScreen}/>}
                {/* {!data.Features.hide && <Testimonials  data={data.Testimonials}  smScreen={smallScreen}/>} */}
                {!data.Features.hide && <OurPeople  data={data.OurPeople}  smScreen={smallScreen}/>}
                {!data.ContactUs.hide && <Contactus/>}
            </main>
            <Footer  data={data.Footer} brand={data.Brand}/>
        </div>
    )
}

export default App;
